import { PageRequest } from '@/core/request/PageRequest';
import { PageResult } from '@/core/request/PageResult';

export enum UserNotificationOriginEnum {
  INVOICE = 'INVOICE',
  WORKORDER = 'WORKORDER',
  STOCK_CORRECTION = 'STOCK_CORRECTION',
  INVENTORY = 'INVENTORY',
  SCHEDULE = 'SCHEDULE',
  FINANCIAL = 'FINANCIAL',
  RELEASE_NOTE = ' RELEASE_NOTE',
  BANK_SLIP = 'BANK_SLIP',
  OTHERS = 'OTHERS',
  WORKORDER_MYBCS = 'WORKORDER_MYBCS',
  BITRIX_TASK_COMPLETED = 'BITRIX_TASK_COMPLETED',
}

export const UserNotificationOriginLabel = {
  [UserNotificationOriginEnum.INVENTORY]: 'Inventário',
  [UserNotificationOriginEnum.WORKORDER]: 'Orçamento',
  [UserNotificationOriginEnum.STOCK_CORRECTION]: 'Correção de estoque',
  [UserNotificationOriginEnum.INVOICE]: 'Nota fiscal',
  [UserNotificationOriginEnum.SCHEDULE]: 'Agendamento',
  [UserNotificationOriginEnum.FINANCIAL]: 'Financeiro',
  [UserNotificationOriginEnum.RELEASE_NOTE]: 'Nota de liberação',
  [UserNotificationOriginEnum.BANK_SLIP]: 'Boleto bancário',
  [UserNotificationOriginEnum.OTHERS]: 'Outros',
  [UserNotificationOriginEnum.WORKORDER_MYBCS]: 'Orçamento MyBCS',
  [UserNotificationOriginEnum.BITRIX_TASK_COMPLETED]: 'Chamado concluído',
};

export const UserNotificationOriginColor = {
  [UserNotificationOriginEnum.INVOICE]: '#fab005',
  [UserNotificationOriginEnum.WORKORDER]: '#7950f2',
  [UserNotificationOriginEnum.STOCK_CORRECTION]: '#40c057',
  [UserNotificationOriginEnum.INVENTORY]: '#228be6',
  [UserNotificationOriginEnum.SCHEDULE]: '#15aabf',
  [UserNotificationOriginEnum.FINANCIAL]: '#e64980',
  [UserNotificationOriginEnum.RELEASE_NOTE]: '#ffa94d',
  [UserNotificationOriginEnum.BANK_SLIP]: '#e64980',
  [UserNotificationOriginEnum.OTHERS]: '#868e96',
  [UserNotificationOriginEnum.WORKORDER_MYBCS]: '#f91e36',
  [UserNotificationOriginEnum.BITRIX_TASK_COMPLETED]: '#40c057',
};

export interface UserNotification {
  notificationId: number;
  message: string;
  origin: UserNotificationOriginEnum;
  userNotificationId: number;
  createdAt: string;
  expiresAt?: string;
  redirectUrl: string;
  isRead: boolean;
  isPriority: boolean;
  entityId?: number;
  metadata?: string;
  description?: string;
}

export interface UserNotificationListRequest extends PageRequest {
  notificationOrigin?: UserNotificationOriginEnum;
  message?: string;
  startDate?: string;
  endDate?: string;
  isRead?: boolean;
  isPriority?: boolean;
}

export type UserNotificationListResponse = PageResult<UserNotification>;

export interface UserNotificationMarkAsReadRequest {
  userNotificationIds: number[];
}
